window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const pusherKey = process.env.MIX_PUSHER_APP_KEY;
if (pusherKey) {
	const pusherScheme = process.env.MIX_PUSHER_SCHEME || 'https';
	const pusherHost = process.env.MIX_PUSHER_HOST
		|| `ws-${process.env.MIX_PUSHER_APP_CLUSTER || 'mt1'}.pusher.com`;
	const pusherPort = Number(process.env.MIX_PUSHER_PORT || (pusherScheme === 'https' ? 443 : 80));

	window.Pusher = Pusher;

	window.Echo = new Echo({
		broadcaster: 'pusher',
		key: pusherKey,
		cluster: process.env.MIX_PUSHER_APP_CLUSTER || 'mt1',
		wsHost: pusherHost,
		wsPort: pusherPort,
		wssPort: pusherPort,
		forceTLS: pusherScheme === 'https',
		encrypted: pusherScheme === 'https',
		enabledTransports: ['ws', 'wss'],
	});
}
